/**
 * @generated SignedSource<<69d84f882fda1e2b0d56caedfa3754ba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedAuctionPrice_item$data = {
  readonly isAuctionEnabled: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"useAuctionPricing_item">;
  readonly " $fragmentType": "SharedAuctionPrice_item";
};
export type SharedAuctionPrice_item$key = {
  readonly " $data"?: SharedAuctionPrice_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedAuctionPrice_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedAuctionPrice_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAuctionEnabled",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useAuctionPricing_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "3e35cddad6725858e5219c016d9bb60e";

export default node;
